export default "__VITE_ASSET__CubZ5OFB__"